import { render, staticRenderFns } from "./leaveTable.vue?vue&type=template&id=0d313df2&scoped=true"
import script from "./leaveTable.vue?vue&type=script&lang=js"
export * from "./leaveTable.vue?vue&type=script&lang=js"
import style0 from "./leaveTable.vue?vue&type=style&index=0&id=0d313df2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d313df2",
  null
  
)

export default component.exports